import { takeLatest } from 'redux-saga';
import { put } from 'redux-saga/effects';
import {
  PARAMETROS_SISTEMA_BUSCAR_POR_ID_BEGIN,
  PARAMETROS_SISTEMA_BUSCAR_POR_ID_SUCCESS,
  PARAMETROS_SISTEMA_BUSCAR_POR_ID_FAILURE,
  PARAMETROS_SISTEMA_BUSCAR_POR_ID_DISMISS_ERROR,
} from './constants';
import * as Services from '../../../sdk/services';

export function buscarPorId(id, callback) {
  // If need to pass args to saga, pass it with the begin action.
  return {
    type: PARAMETROS_SISTEMA_BUSCAR_POR_ID_BEGIN,
    data: id,
    callback,
  };
}

export function dismissBuscarPorIdError() {
  return {
    type: PARAMETROS_SISTEMA_BUSCAR_POR_ID_DISMISS_ERROR,
  };
}

// worker Saga: will be fired on PARAMETROS_SISTEMA_BUSCAR_POR_ID_BEGIN actions
export function* doBuscarPorId(action) {
  // If necessary, use argument to receive the begin action with parameters.
  let res;
  const ParametroSistemaApi = new Services['ParametroSistemaApi']();
  try {
    // Do Ajax call or other async request here. delay(20) is just a placeholder.
    res = yield ParametroSistemaApi.findById(action.data);
  } catch (err) {
    yield put({
      type: PARAMETROS_SISTEMA_BUSCAR_POR_ID_FAILURE,
      data: { error: err },
    });
    if (action.callback) {
      action.callback(PARAMETROS_SISTEMA_BUSCAR_POR_ID_FAILURE);
    }
    return;
  }
  // Dispatch success action out of try/catch so that render errors are not catched.
  yield put({
    type: PARAMETROS_SISTEMA_BUSCAR_POR_ID_SUCCESS,
    data: res,
  });

  if (action.callback) {
    action.callback(PARAMETROS_SISTEMA_BUSCAR_POR_ID_SUCCESS, res);
  }
}

/*
  Alternatively you may use takeEvery.

  takeLatest does not allow concurrent requests. If an action gets
  dispatched while another is already pending, that pending one is cancelled
  and only the latest one will be run.
*/
export function* watchBuscarPorId() {
  yield takeLatest(PARAMETROS_SISTEMA_BUSCAR_POR_ID_BEGIN, doBuscarPorId);
}

// Redux reducer
export function reducer(state, action) {
  switch (action.type) {
    case PARAMETROS_SISTEMA_BUSCAR_POR_ID_BEGIN:
      return {
        ...state,
        registro: {},
        buscarPorIdPending: true,
        buscarPorIdError: null,
      };

    case PARAMETROS_SISTEMA_BUSCAR_POR_ID_SUCCESS:
      return {
        ...state,
        registro: action.data,
        buscarPorIdPending: false,
        buscarPorIdError: null,
      };

    case PARAMETROS_SISTEMA_BUSCAR_POR_ID_FAILURE:
      return {
        ...state,
        buscarPorIdPending: false,
        buscarPorIdError: action.data.error,
      };

    case PARAMETROS_SISTEMA_BUSCAR_POR_ID_DISMISS_ERROR:
      return {
        ...state,
        buscarPorIdError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/parametros-sistema/redux/buscarPorId.js